<nx-pageTitle-box class="mb-3" 
  [label]="'core.timeEntryCategoryList.pageTitleBox.label'" 
  [icon]="'icon-time'" 
  [iconToolTip]="'core.timeEntryCategoryList.pageTitleBox.iconToolTip'"
  [bcRootLvlLabel]="'core.settings.label'"
  [bcRootLvlPath]="'settings'">
</nx-pageTitle-box>

<nx-table-header
  label="core.timeEntryCategoryList.label">
  <ng-template nxTemplate="end">
    <nx-default-button
      (click)="createTimeTrackingCategory()"
      [style]="'light'"
      [label]="'core.timeEntryCategoryList.tableHeader.addTimeCategoryEntry'"
      [icon]="'icon-plus'">
    </nx-default-button>
  </ng-template>
</nx-table-header>
<p-table
  #userTable
  [lazy]="true"
  (onLazyLoad)="loadData($any($event))"
  [value]="dataSource?.data" 
  [scrollable]="true"
  [paginator]="true"
  [rows]="15"
  [rowsPerPageOptions]="[15, 20, 50]"
  [totalRecords]="dataSource?.totalElements"
  [loading]="loading"
  [sortField]="sortProperty" 
  [sortOrder]="translateSortDirectionToSortOrder(sortDirection)"
  [showCurrentPageReport]="true"
  [filterDelay]="200"
  [currentPageReportTemplate]="'{first} - {last} ' + ('core.common.paginator.currentPageReportSpacer' | translate) +' {totalRecords}'"
  [resizableColumns]="true">
  <ng-template pTemplate="caption">
    <div class="flex flex-row">
      <div class="basis-2/3 flex flex-row gap-2">
        <!-- <p-columnFilter class="licenceType" field="licenceType" matchMode="in" [showMenu]="false" [showMatchModes]="false"
          [showOperator]="false" [showAddButton]="false" [showApplyButton]="false" [showClearButton]="false"
          [showButtons]="false">
          <ng-template pTemplate="filter" let-value let-filter="filterCallback">
            <nx-filter-multiSelect
              [className]="'table-filter'"
              [filter]="false"
              [showToggleAll]="false"
              [showHeader]="false"
              [appendTo]="'body'"
              [(ngModel)] = "licenceTypesModel"
              [options]="licenceTypes"
              [showClear]="true"
              [placeholder]="'core.userList.licence' | translate"
              (onClear)="filter($event)"
              (onChange)="filter($any($event).value)"
              optionLabel="name">
            </nx-filter-multiSelect>
          </ng-template>
        </p-columnFilter>-->
        <p-columnFilter class="enabled" field="enabled" matchMode="in" [showMenu]="false" [showMatchModes]="false"
          [showOperator]="false" [showAddButton]="false" [showApplyButton]="false" [showClearButton]="false"
          [showButtons]="false" >
          <ng-template pTemplate="filter" let-value let-filter="filterCallback">
            <nx-filter-dropdown
              [className]="'table-filter'"
              [filter]="false"
              [appendTo]="'body'"
              [showClear]="true"
              [options]="status | translateLabels"
              (onClear)="filter($event)"
              (onChange)="filter($any($event).value)"
              [placeholder]="'core.userList.state' | translate"
              optionLabel="label">
            </nx-filter-dropdown>
          </ng-template> 
        </p-columnFilter> 
      </div>
      <div class="basis-1/3 flex flex-row justify-end">
        <p-dropdown
          placeholder="Sortierung"
          [styleClass]="'sort'"
          appendTo="body" 
          [ngModel] = "sortModel"
          [options]="sortOptions | translateLabels"
          optionLabel="label"
          [showClear]="false"
          (onChange)="sort($event)">
        </p-dropdown>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="header">  

    <tr>
        <th>{{'core.timeEntryCategoryList.tableHeader.name' | translate}}</th>
        <th>{{'core.timeEntryCategoryList.tableHeader.externalId' | translate}}</th>
        <th>{{'core.timeEntryCategoryList.tableHeader.enabled' | translate}}</th>
    </tr>
    <!-- <tr>
      <th><p-columnFilter type="text" [showMenu]="false" [placeholder]="'core.common.searchPlaceholder' | translate" field="email" [showClearButton]="true"></p-columnFilter></th>
      <th><p-columnFilter type="text" [showMenu]="false" [placeholder]="'core.common.searchPlaceholder' | translate" field="firstName" [showClearButton]="true"></p-columnFilter></th>
      <th><p-columnFilter type="text" [showMenu]="false" [placeholder]="'core.common.searchPlaceholder' | translate" field="lastName" [showClearButton]="true"></p-columnFilter></th>
      <th></th>
      <th></th>
    </tr> -->
  </ng-template>
  <ng-template pTemplate="body" let-timeEntryCategory>
    <tr class="clickable" (click)="openTimeEntryCategory(timeEntryCategory)">
      <td>
        <div class="flex items-center gap-2">
          <div class="w-2 h-2 rounded-full flex-shrink-0" [style.background-color]="timeEntryCategory.color || '#2196f3'"></div>
          {{timeEntryCategory.name}}
        </div>
      </td>
      <td>{{timeEntryCategory.externalId}}</td>
      <td>
        <p-tag 
          [value]="(timeEntryCategory?.enabled ? 'core.timeEntryCategory.enabled.true' : 'core.timeEntryCategory.enabled.false') | translate"
          [severity]="timeEntryCategory?.enabled ? 'success' : 'danger'">
        </p-tag>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="8" class="emptyMessage">{{'core.timeEntryCategoryList.noTimeEntriesFound' | translate }}</td>
    </tr>
  </ng-template>
</p-table>
